import Container    from '../../../components/Theme/Dashboard';
import Table    from '../../../components/Table';
import View from './View';
import Create from './Create';
import usePermissions from '../../../hooks/usePermissions';


const td  = [
  {
    label:"Evento",
    field:"name",
    className:"",
    align:"left",
  },
  {
    label:"Fecha Inicio",
    field:"inicio",
    className:"",
    align:"left",
  },
  {
    label:"Fecha Culminación",
    field:"final",
    className:"",
    align:"left",
  },
  {
    label:"Cliente",
    field:"cliente",
    className:"",
    align:"left",
  },{
    label:"Teléfono",
    field:"celular",
    className:"",
    align:"left",
  },
  {
    label:"Acción",
    field:"event",
    className:"",
    align:"center",
    event:[
      {
        label:"Editar",
        action:"edit",
        component:View,
      },
      {
        label:"Ver",
        action:"view",
        byIndex:{
                  prefixed:"./evento",
                  key:"id"
                },
      },
    ]
  },
]

const Home=(props)=>{
  const permissions     =   usePermissions("clientes","index",{
                                                                component:Table,
                                                                td:td,
                                                                create:Create
                                                              });
  return  <Container>
            {permissions.render()}
          </Container>
}
export default Home
